import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import * as categoryActions from './category.actions';
import { CategoryService } from '../../services/category/category.service';
import { DashboardCamelCasePipe } from '../../../core/pipes/dashboard-camel-case/dashboard-camel-case.pipe';

@Injectable()
export class CategoryEffects {
  saveCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoryActions.saveCategory),
      switchMap(({ label, studyId }) => {
        return this.categoryService.saveCategory(label, studyId).pipe(
          map((newCategory) =>
            categoryActions.saveCategorySuccess({
              newCategory: this.dashboardCamelCasePipe.keysToCamelCase(newCategory),
            })
          ),
          catchError((err: HttpErrorResponse) => of(categoryActions.saveCategoryError({ err })))
        );
      })
    )
  );

  saveCategorySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(categoryActions.saveCategorySuccess),
        tap(({ newCategory }) => {
          this.toastrService.success(`Successfully saved category ${newCategory?.label}`);
        })
      ),
    { dispatch: false }
  );

  saveCategoryError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(categoryActions.saveCategoryError),
        tap(() => {
          this.toastrService.error('Unable to save Category');
        })
      ),
    { dispatch: false }
  );

  deleteCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoryActions.deleteCategory),
      switchMap(({ category, studyId }) => {
        return this.categoryService.deleteCategory(category?.id, studyId).pipe(
          map(() => categoryActions.deleteCategorySuccess({ deletedCategory: category })),
          catchError((err: HttpErrorResponse) => of(categoryActions.deleteCategoryError({ err })))
        );
      })
    )
  );

  deleteCategorySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(categoryActions.deleteCategorySuccess),
        tap(({ deletedCategory }) => {
          this.toastrService.success(`Successfully deleted category ${deletedCategory?.label}`);
        })
      ),
    { dispatch: false }
  );

  deleteCategoryError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(categoryActions.deleteCategoryError),
        tap(() => {
          this.toastrService.error('Unable to delete Category');
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private categoryService: CategoryService,
    private dashboardCamelCasePipe: DashboardCamelCasePipe,
    private toastrService: ToastrService
  ) {}
}
